import { render, staticRenderFns } from "./StoryComp.vue?vue&type=template&id=2fdcef59&scoped=true"
import script from "./StoryComp.vue?vue&type=script&lang=js"
export * from "./StoryComp.vue?vue&type=script&lang=js"
import style0 from "./StoryComp.vue?vue&type=style&index=0&id=2fdcef59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdcef59",
  null
  
)

export default component.exports